<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-08 22:05:48
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-19 16:47:37
-->
<template>
	<!-- 修改备注 -->
	<el-dialog
		width="400px"
		title="确定要取消绑定？"
		:visible.sync="visible"
		:append-to-body="true"
		:before-close="beforeClose"
		:close-on-click-modal="false"
	>
		<div class="flex-row flex-just-start yx-color-text-primary font-h4-regular">
			<i class="el-icon-warning yx-color-warning mt-4"></i>
			<p class="ml-4">
				取消绑定后无法给商家继续发送新样品协作，同时已发送待处理的协作申请将失效恢复成"待同步"状态
			</p>
		</div>
		<div class="mt-20 flex-row flex-just-start">
			<p class="yx-color-text-primary font-h4-regular nowrap ml-16 mr-10"><span class="yx-color-danger">*</span><span>原因</span></p>
			<el-input v-model="remark" autocomplete="off" :autosize="{ minRows: 4 }" type="textarea" maxlength="200" show-word-limit></el-input>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button @click="beforeClose">取 消</el-button>
			<el-button type="primary" @click="confirm" :disabled="isDisabled">确认取消绑定</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { cancelBind } from '@/api/cooperativeShop';
export default {
	name: 'remarkDialog',
	computed: {
		isDisabled({ remark }) {
			return !remark;
		},
	},
	data() {
		return {
			visible: false,
			remark: '',
			outerShopId: '',
		};
	},
	components: {},
	methods: {
		//备注弹框
		show(bindId = '') {
			this.bindId = bindId;
			this.visible = true;
		},
		//提交备注
		async confirm() {
			const { bindId, remark } = this;
			await cancelBind({ remark, bindId });
			this.$message.success('操作成功！');
			this.$emit('refresh');
			this.beforeClose();
		},
		beforeClose() {
			this.remark = '';
			this.outerShopId = '';
			this.visible = false;
		},
	},
};
</script>
<style scoped></style>
